/**
 * FeedbackButton Component
 *
 * Quarter circle button for opening the feedback modal.
 * Positioned at bottom-left corner and visible on all authenticated pages.
 */

import React, { useState } from 'react';
import { Box } from '@mui/material';
import { useAuth } from '../../context/AuthContext';
import FeedbackModal from './FeedbackModal';

// Icons
import BugReportIcon from '@mui/icons-material/BugReport';
import FeedbackIcon from '@mui/icons-material/Feedback';

const FeedbackButton = ({ useAlternateIcon = false }) => {
  const { currentUser } = useAuth();
  const [modalOpen, setModalOpen] = useState(false);

  // Only show for authenticated users
  if (!currentUser) {
    return null;
  }

  const handleOpen = () => {
    setModalOpen(true);
  };

  const handleClose = () => {
    setModalOpen(false);
  };

  return (
    <>
      {/* Quarter Circle Feedback Button */}
      <Box
        onClick={handleOpen}
        data-no-screenshot  // Exclude from screenshots
        sx={{
          position: 'fixed',
          bottom: 0,
          left: 0,
          width: 40,
          height: 40,
          backgroundColor: 'primary.main',
          color: 'white',
          borderTopRightRadius: '100%',
          display: 'flex',
          alignItems: 'flex-end',
          justifyContent: 'flex-start',
          padding: '6px',
          cursor: 'pointer',
          zIndex: 1400,  // Above modals (1300) so always clickable for screenshots
          boxShadow: 3,
          transformOrigin: 'bottom left',
          transition: 'width 0.3s cubic-bezier(0.4, 0, 0.2, 1), height 0.3s cubic-bezier(0.4, 0, 0.2, 1), padding 0.3s cubic-bezier(0.4, 0, 0.2, 1), background-color 0.3s cubic-bezier(0.4, 0, 0.2, 1), box-shadow 0.3s cubic-bezier(0.4, 0, 0.2, 1)',
          '&:hover': {
            backgroundColor: 'primary.dark',
            boxShadow: 6,
            width: 80,
            height: 80,
            padding: '12px',
          },
          '& svg': {
            fontSize: '1rem',
            transition: 'font-size 0.3s cubic-bezier(0.4, 0, 0.2, 1)',
          },
          '&:hover svg': {
            fontSize: '3rem',
          }
        }}
        title="Feedback geben"
      >
        {useAlternateIcon ? <FeedbackIcon /> : <BugReportIcon />}
      </Box>

      {/* Feedback Modal */}
      <FeedbackModal
        open={modalOpen}
        onClose={handleClose}
      />
    </>
  );
};

export default FeedbackButton;
